import {Component, OnInit} from '@angular/core';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {User} from "../type/user";

declare var jQuery: any;

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
})
export class UsersComponent implements OnInit {
    node = 'user';
    users: [User] = [User];

    isChecked = false;
    checkedList = [];

    constructor(
        private dataService: DataService,
        private apiService: ApiService
    ) {}

    ngOnInit() {
        this.dataService.refresh();
        this.getAll();
    }

    resetData() {
        this.getAll();
        this.isChecked = false;
        this.checkedList = [];
    }

    getAll(): void {
        this.apiService.getAll(this.node)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.users = [User];
                    } else {
                        this.users = response.json().data;
                    }
                });
    }

    onDelete() {
        if (confirm('Are you absolutely sure you want to delete?')) {
            this.apiService.delete(this.node, this.checkedList)
                .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Unable to delete user');
                    } else {
                        this.resetData();
                        alert('User Deleted Successfully');
                    }
                });
        }
    }

    updateCheckList(id) {
        if (this.checkedList.indexOf(id) == -1) {
            this.checkedList.push(id);
        } else {
            this.checkedList.splice(this.checkedList.indexOf(id), 1);
        }
    }

    toggleCheckBox() {
        this.isChecked = !this.isChecked;
        if (this.isChecked == true) {
            this.checkedList = this.users.map(function(a) {return a.user_id;});
        } else {
            this.checkedList = [];
        }
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }
}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts